"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberFactory = exports.Member = void 0;
function Member(initial = null) {
    return function (target, propertyKey) {
        Object.defineProperty(target, propertyKey, {
            get() {
                Object.defineProperty(this, propertyKey, {
                    value: initial,
                    writable: true,
                    configurable: true,
                    enumerable: true,
                });
                return initial;
            },
            set(value) {
                Object.defineProperty(this, propertyKey, {
                    value,
                    writable: true,
                    configurable: true,
                    enumerable: true,
                });
            },
            configurable: true,
            enumerable: true,
        });
    };
}
exports.Member = Member;
function MemberFactory(initialFactory) {
    return function (target, propertyKey) {
        Object.defineProperty(target, propertyKey, {
            get() {
                const value = initialFactory(this);
                Object.defineProperty(this, propertyKey, {
                    value,
                    writable: true,
                    configurable: true,
                    enumerable: true,
                });
                return value;
            },
            set(value) {
                Object.defineProperty(this, propertyKey, {
                    value,
                    writable: true,
                    configurable: true,
                    enumerable: true,
                });
            },
            configurable: true,
            enumerable: true,
        });
    };
}
exports.MemberFactory = MemberFactory;
